

import React, { memo } from 'react';
import { QUARTER } from '../constants/months';
import createMonthsMap from '../utils/createMonthsMap';
import countVideosPerMonth from '../utils/countVideosPerMonth';
import HeatmapValueCell from './HeatmapValueCell';
import HeatmapContainer from '../containers/Heatmap';








function HeatmapWithValues({ videos, quota, monthsCount, onCellClick }) {
  let pointer = 0;
  let colorNumber = 0;

  const monthsMap = countVideosPerMonth({ monthsMap: createMonthsMap(monthsCount), videos });

  const months = Array.from(monthsMap);

  return (
    <HeatmapContainer>
      {months.map((item) => {
        const monthNumber = item[0];
        const videosInMonth = item[1];

        if (pointer === QUARTER) {
          colorNumber += 1;
          pointer = 0;
        } else {
          pointer += 1;
        }

        return (
          <HeatmapValueCell
            key={monthNumber}
            quota={quota}
            colorNumber={colorNumber}
            videos={videosInMonth}
            onCellClick={onCellClick} />);


      })}
    </HeatmapContainer>);

}

export default memo(HeatmapWithValues);